import ProjectItem from "../../models/ProjectItem";


export const projectList = [
    new ProjectItem("NewMotion", ["#design", "#research", "#animation"], "newmotion"),
    new ProjectItem("Proximity", ["#design"], "proximity"),
    new ProjectItem("Stibbel", ["#design", "#front-end"], "stibbel"),
    new ProjectItem("WeatherApp", ["#front-end", "#react"], "weatherapp"),
]

